"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cpReportSaga;
var _effects = require("redux-saga/effects");
var _cpReport = require("./cpReport.action");
var _cpReport2 = require("./cpReport.constant");
var _services = require("../../../../services");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(cpReportSaga);
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; } // @flow
/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function cpReportGetReportDefault(_ref) {
  var payload = _ref.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _response$data, response;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(_services.cpReportGetReportDefaultApi, payload);
        case 3:
          response = _context.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.code) === 200)) {
            _context.next = 9;
            break;
          }
          _context.next = 7;
          return (0, _effects.put)((0, _cpReport.cpReportSuccess)(_cpReport2.actionTypes.GET_REPORT_DEFAULT, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context.next = 11;
          break;
        case 9:
          _context.next = 11;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.GET_REPORT_DEFAULT, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context.next = 17;
          break;
        case 13:
          _context.prev = 13;
          _context.t0 = _context["catch"](0);
          _context.next = 17;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.GET_REPORT_DEFAULT, _context.t0));
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 13]]);
  })();
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
function cpReportAddReportDefault(_ref2) {
  var payload = _ref2.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var _response$data2, response;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(_services.cpReportAddReportDefaultApi, payload);
        case 3:
          response = _context2.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.code) === 202)) {
            _context2.next = 9;
            break;
          }
          _context2.next = 7;
          return (0, _effects.put)((0, _cpReport.cpReportSuccess)(_cpReport2.actionTypes.ADD_REPORT_DEFAULT, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context2.next = 11;
          break;
        case 9:
          _context2.next = 11;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.ADD_REPORT_DEFAULT, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context2.next = 17;
          break;
        case 13:
          _context2.prev = 13;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 17;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.ADD_REPORT_DEFAULT, _context2.t0));
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 13]]);
  })();
}

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function cpReportAddUpdateReportDefault(_ref3) {
  var payload = _ref3.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var _response$data3, response;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return (0, _effects.call)(_services.cpReportAddUpdateReportDefaultApi, payload);
        case 3:
          response = _context3.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.code) === 202)) {
            _context3.next = 9;
            break;
          }
          _context3.next = 7;
          return (0, _effects.put)((0, _cpReport.cpReportSuccess)(_cpReport2.actionTypes.ADD_UPDATE_REPORT_DEFAULT_CP, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context3.next = 11;
          break;
        case 9:
          _context3.next = 11;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.ADD_UPDATE_REPORT_DEFAULT_CP, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context3.next = 17;
          break;
        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](0);
          _context3.next = 17;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.ADD_UPDATE_REPORT_DEFAULT_CP, _context3.t0));
        case 17:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 13]]);
  })();
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
function cpReportGetReportDefaultByOrgId(_ref4) {
  var payload = _ref4.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
    var _response$data4, response;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return (0, _effects.call)(_services.cpReportGetReportDefaultByOrgIdApi, payload);
        case 3:
          response = _context4.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.code) === 200)) {
            _context4.next = 9;
            break;
          }
          _context4.next = 7;
          return (0, _effects.put)((0, _cpReport.cpReportSuccess)(_cpReport2.actionTypes.GET_REPORT_BY_ID, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context4.next = 11;
          break;
        case 9:
          _context4.next = 11;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.GET_REPORT_BY_ID, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context4.next = 17;
          break;
        case 13:
          _context4.prev = 13;
          _context4.t0 = _context4["catch"](0);
          _context4.next = 17;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.GET_REPORT_BY_ID, _context4.t0));
        case 17:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 13]]);
  })();
}

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function cpReportUpdateGreeting(_ref5) {
  var payload = _ref5.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var _response$data5, response;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return (0, _effects.call)(_services.cpReportUpdateGreetingApi, payload);
        case 3:
          response = _context5.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.code) === 200)) {
            _context5.next = 9;
            break;
          }
          _context5.next = 7;
          return (0, _effects.put)((0, _cpReport.cpReportSuccess)(_cpReport2.actionTypes.UPDATE_GREETING, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context5.next = 11;
          break;
        case 9:
          _context5.next = 11;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.UPDATE_GREETING, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context5.next = 17;
          break;
        case 13:
          _context5.prev = 13;
          _context5.t0 = _context5["catch"](0);
          _context5.next = 17;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.UPDATE_GREETING, _context5.t0));
        case 17:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 13]]);
  })();
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
function cpReportUpdateHeaderImage(_ref6) {
  var payload = _ref6.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
    var _response$data6, response;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return (0, _effects.call)(_services.cpReportUpdateHeaderImageApi, payload);
        case 3:
          response = _context6.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.code) === 202)) {
            _context6.next = 9;
            break;
          }
          _context6.next = 7;
          return (0, _effects.put)((0, _cpReport.cpReportSuccess)(_cpReport2.actionTypes.UPDATE_HEADER_IMAGE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context6.next = 11;
          break;
        case 9:
          _context6.next = 11;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.UPDATE_HEADER_IMAGE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context6.next = 17;
          break;
        case 13:
          _context6.prev = 13;
          _context6.t0 = _context6["catch"](0);
          _context6.next = 17;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.UPDATE_HEADER_IMAGE, _context6.t0));
        case 17:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 13]]);
  })();
}

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to delete data.
 */
function cpReportUpdateFundSequencePanel(_ref7) {
  var payload = _ref7.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
    var _response$data7, response;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _effects.call)(_services.cpReportUpdateFundSequencePanelApi, payload);
        case 3:
          response = _context7.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data7 = response.data) === null || _response$data7 === void 0 ? void 0 : _response$data7.code) === 202)) {
            _context7.next = 9;
            break;
          }
          _context7.next = 7;
          return (0, _effects.put)((0, _cpReport.cpReportSuccess)(_cpReport2.actionTypes.UPDATE_PANEL_SEQUENCE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context7.next = 11;
          break;
        case 9:
          _context7.next = 11;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.UPDATE_PANEL_SEQUENCE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context7.next = 17;
          break;
        case 13:
          _context7.prev = 13;
          _context7.t0 = _context7["catch"](0);
          _context7.next = 17;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.UPDATE_PANEL_SEQUENCE, _context7.t0));
        case 17:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 13]]);
  })();
}

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function cpReportGetHeaderImage(_ref8) {
  var payload = _ref8.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
    var _response$data8, response;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _effects.call)(_services.cpReportGetHeaderImageApi, payload);
        case 3:
          response = _context8.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data8 = response.data) === null || _response$data8 === void 0 ? void 0 : _response$data8.code) === 200)) {
            _context8.next = 9;
            break;
          }
          _context8.next = 7;
          return (0, _effects.put)((0, _cpReport.cpReportSuccess)(_cpReport2.actionTypes.GET_HEADER_IMAGE, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context8.next = 11;
          break;
        case 9:
          _context8.next = 11;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.GET_HEADER_IMAGE, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context8.next = 17;
          break;
        case 13:
          _context8.prev = 13;
          _context8.t0 = _context8["catch"](0);
          _context8.next = 17;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.GET_HEADER_IMAGE, _context8.t0));
        case 17:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[0, 13]]);
  })();
}

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function cpReportGetBuilderReportById(_ref9) {
  var payload = _ref9.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
    var _response$data9, response;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _context9.prev = 0;
          _context9.next = 3;
          return (0, _effects.call)(_services.cpReportGetBuilderReportByIdApi, payload);
        case 3:
          response = _context9.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data9 = response.data) === null || _response$data9 === void 0 ? void 0 : _response$data9.code) === 200)) {
            _context9.next = 9;
            break;
          }
          _context9.next = 7;
          return (0, _effects.put)((0, _cpReport.cpReportSuccess)(_cpReport2.actionTypes.GET_BUILDER_REPORT_BY_ID, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context9.next = 11;
          break;
        case 9:
          _context9.next = 11;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.GET_BUILDER_REPORT_BY_ID, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context9.next = 17;
          break;
        case 13:
          _context9.prev = 13;
          _context9.t0 = _context9["catch"](0);
          _context9.next = 17;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.GET_BUILDER_REPORT_BY_ID, _context9.t0));
        case 17:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[0, 13]]);
  })();
}

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function cpReportGetAssetFolderList(_ref10) {
  var payload = _ref10.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
    var _response$data10, response;
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          _context10.next = 3;
          return (0, _effects.call)(_services.cpReportGetAssetFolderListApi, payload);
        case 3:
          response = _context10.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data10 = response.data) === null || _response$data10 === void 0 ? void 0 : _response$data10.code) === 200)) {
            _context10.next = 9;
            break;
          }
          _context10.next = 7;
          return (0, _effects.put)((0, _cpReport.cpReportSuccess)(_cpReport2.actionTypes.GET_ASSET_FOLDER_LIST, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context10.next = 11;
          break;
        case 9:
          _context10.next = 11;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.GET_ASSET_FOLDER_LIST, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context10.next = 17;
          break;
        case 13:
          _context10.prev = 13;
          _context10.t0 = _context10["catch"](0);
          _context10.next = 17;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.GET_ASSET_FOLDER_LIST, _context10.t0));
        case 17:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[0, 13]]);
  })();
}

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function cpReportPanelList(_ref11) {
  var payload = _ref11.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    var _response$data11, response;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.prev = 0;
          _context11.next = 3;
          return (0, _effects.call)(_services.cpReportPanelListApi, payload);
        case 3:
          response = _context11.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data11 = response.data) === null || _response$data11 === void 0 ? void 0 : _response$data11.code) === 200)) {
            _context11.next = 9;
            break;
          }
          _context11.next = 7;
          return (0, _effects.put)((0, _cpReport.cpReportSuccess)(_cpReport2.actionTypes.PANEL_LIST, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context11.next = 11;
          break;
        case 9:
          _context11.next = 11;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.PANEL_LIST, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context11.next = 17;
          break;
        case 13:
          _context11.prev = 13;
          _context11.t0 = _context11["catch"](0);
          _context11.next = 17;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.PANEL_LIST, _context11.t0));
        case 17:
        case "end":
          return _context11.stop();
      }
    }, _callee11, null, [[0, 13]]);
  })();
}

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function cpReportGetGreeting(_ref12) {
  var payload = _ref12.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
    var _response$data12, response;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.prev = 0;
          _context12.next = 3;
          return (0, _effects.call)(_services.cpReportGetGreetingApi, payload);
        case 3:
          response = _context12.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data12 = response.data) === null || _response$data12 === void 0 ? void 0 : _response$data12.code) === 200)) {
            _context12.next = 9;
            break;
          }
          _context12.next = 7;
          return (0, _effects.put)((0, _cpReport.cpReportSuccess)(_cpReport2.actionTypes.GET_GREETING, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context12.next = 11;
          break;
        case 9:
          _context12.next = 11;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.GET_GREETING, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context12.next = 17;
          break;
        case 13:
          _context12.prev = 13;
          _context12.t0 = _context12["catch"](0);
          _context12.next = 17;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.GET_GREETING, _context12.t0));
        case 17:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[0, 13]]);
  })();
}

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to delete data.
 */
function cpReportDeletePanel(_ref13) {
  var payload = _ref13.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
    var _response$data13, response;
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.prev = 0;
          _context13.next = 3;
          return (0, _effects.call)(_services.cpReportDeletePanelApi, payload);
        case 3:
          response = _context13.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data13 = response.data) === null || _response$data13 === void 0 ? void 0 : _response$data13.code) === 202)) {
            _context13.next = 9;
            break;
          }
          _context13.next = 7;
          return (0, _effects.put)((0, _cpReport.cpReportSuccess)(_cpReport2.actionTypes.DELETE_PANEL, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context13.next = 11;
          break;
        case 9:
          _context13.next = 11;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.DELETE_PANEL, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context13.next = 17;
          break;
        case 13:
          _context13.prev = 13;
          _context13.t0 = _context13["catch"](0);
          _context13.next = 17;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.DELETE_PANEL, _context13.t0));
        case 17:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[0, 13]]);
  })();
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
function cpReportUpdatePanel(_ref14) {
  var payload = _ref14.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
    var _response$data14, response;
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.prev = 0;
          _context14.next = 3;
          return (0, _effects.call)(_services.cpReportUpdatePanelApi, payload);
        case 3:
          response = _context14.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data14 = response.data) === null || _response$data14 === void 0 ? void 0 : _response$data14.code) === 201)) {
            _context14.next = 9;
            break;
          }
          _context14.next = 7;
          return (0, _effects.put)((0, _cpReport.cpReportSuccess)(_cpReport2.actionTypes.UPDATE_PANEL, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context14.next = 11;
          break;
        case 9:
          _context14.next = 11;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.UPDATE_PANEL, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context14.next = 17;
          break;
        case 13:
          _context14.prev = 13;
          _context14.t0 = _context14["catch"](0);
          _context14.next = 17;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.UPDATE_PANEL, _context14.t0));
        case 17:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[0, 13]]);
  })();
}

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function cpReportGetHeaderImageList(_ref15) {
  var payload = _ref15.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
    var _response$data15, response;
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.prev = 0;
          _context15.next = 3;
          return (0, _effects.call)(_services.cpReportGetHeaderImageListApi, payload);
        case 3:
          response = _context15.sent;
          if (!((response === null || response === void 0 ? void 0 : (_response$data15 = response.data) === null || _response$data15 === void 0 ? void 0 : _response$data15.code) === 200)) {
            _context15.next = 9;
            break;
          }
          _context15.next = 7;
          return (0, _effects.put)((0, _cpReport.cpReportSuccess)(_cpReport2.actionTypes.GET_HEADER_IMAGE_LIST, response === null || response === void 0 ? void 0 : response.data));
        case 7:
          _context15.next = 11;
          break;
        case 9:
          _context15.next = 11;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.GET_HEADER_IMAGE_LIST, response === null || response === void 0 ? void 0 : response.data));
        case 11:
          _context15.next = 17;
          break;
        case 13:
          _context15.prev = 13;
          _context15.t0 = _context15["catch"](0);
          _context15.next = 17;
          return (0, _effects.put)((0, _cpReport.cpReportError)(_cpReport2.actionTypes.GET_HEADER_IMAGE_LIST, _context15.t0));
        case 17:
        case "end":
          return _context15.stop();
      }
    }, _callee15, null, [[0, 13]]);
  })();
}
var watchCpReport = function watchCpReport() {
  return /*#__PURE__*/_regeneratorRuntime().mark(function watch() {
    return _regeneratorRuntime().wrap(function watch$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return (0, _effects.takeLatest)(_cpReport2.actionTypes.GET_REPORT_DEFAULT, cpReportGetReportDefault);
        case 2:
          _context16.next = 4;
          return (0, _effects.takeLatest)(_cpReport2.actionTypes.ADD_REPORT_DEFAULT, cpReportAddReportDefault);
        case 4:
          _context16.next = 6;
          return (0, _effects.takeLatest)(_cpReport2.actionTypes.ADD_UPDATE_REPORT_DEFAULT_CP, cpReportAddUpdateReportDefault);
        case 6:
          _context16.next = 8;
          return (0, _effects.takeLatest)(_cpReport2.actionTypes.GET_REPORT_BY_ID, cpReportGetReportDefaultByOrgId);
        case 8:
          _context16.next = 10;
          return (0, _effects.takeLatest)(_cpReport2.actionTypes.UPDATE_GREETING, cpReportUpdateGreeting);
        case 10:
          _context16.next = 12;
          return (0, _effects.takeLatest)(_cpReport2.actionTypes.UPDATE_HEADER_IMAGE, cpReportUpdateHeaderImage);
        case 12:
          _context16.next = 14;
          return (0, _effects.takeLatest)(_cpReport2.actionTypes.UPDATE_PANEL_SEQUENCE, cpReportUpdateFundSequencePanel);
        case 14:
          _context16.next = 16;
          return (0, _effects.takeLatest)(_cpReport2.actionTypes.GET_HEADER_IMAGE, cpReportGetHeaderImage);
        case 16:
          _context16.next = 18;
          return (0, _effects.takeLatest)(_cpReport2.actionTypes.GET_BUILDER_REPORT_BY_ID, cpReportGetBuilderReportById);
        case 18:
          _context16.next = 20;
          return (0, _effects.takeLatest)(_cpReport2.actionTypes.GET_ASSET_FOLDER_LIST, cpReportGetAssetFolderList);
        case 20:
          _context16.next = 22;
          return (0, _effects.takeLatest)(_cpReport2.actionTypes.PANEL_LIST, cpReportPanelList);
        case 22:
          _context16.next = 24;
          return (0, _effects.takeLatest)(_cpReport2.actionTypes.GET_GREETING, cpReportGetGreeting);
        case 24:
          _context16.next = 26;
          return (0, _effects.takeLatest)(_cpReport2.actionTypes.DELETE_PANEL, cpReportDeletePanel);
        case 26:
          _context16.next = 28;
          return (0, _effects.takeLatest)(_cpReport2.actionTypes.UPDATE_PANEL, cpReportUpdatePanel);
        case 28:
          _context16.next = 30;
          return (0, _effects.takeLatest)(_cpReport2.actionTypes.GET_HEADER_IMAGE_LIST, cpReportGetHeaderImageList);
        case 30:
        case "end":
          return _context16.stop();
      }
    }, watch);
  });
};
function cpReportSaga() {
  return _regeneratorRuntime().wrap(function cpReportSaga$(_context17) {
    while (1) switch (_context17.prev = _context17.next) {
      case 0:
        _context17.next = 2;
        return (0, _effects.all)([(0, _effects.fork)(watchCpReport())]);
      case 2:
      case "end":
        return _context17.stop();
    }
  }, _marked);
}